import dayjs from "dayjs"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"

import LinkList from "@molecules/LinkList/LinkList"

const LinkListBlock = ({ blockDataRSSFeed }) => {
  const customParseFormat = require("dayjs/plugin/customParseFormat")
  dayjs.extend(customParseFormat)

  const { heading, selectedFeed, limit, link } = blockDataRSSFeed || {}

  const allFeeds = useStaticQuery(
    graphql`
      {
        hr: allFeedHrJaJohtaminen {
          edges {
            node {
              id
              title
              content
              link
            }
          }
        }
        julkishallinto: allFeedJulkishallinto {
          edges {
            node {
              id
              title
              content
              link
            }
          }
        }
        lakimiesliitto: allFeedLakimiesliitonKoulutus {
          edges {
            node {
              id
              title
              content
              link
            }
          }
        }
        taloushallinto: allFeedTaloushallinto {
          edges {
            node {
              id
              title
              content
              link
            }
          }
        }
      }
    `
  )

  let query = null

  switch (selectedFeed) {
    case "HR ja johtaminen":
      query = allFeeds?.hr
      break
    case "Julkishallinto":
      query = allFeeds?.julkishallinto
      break
    case "Lakimiesliiton koulutus":
      query = allFeeds?.lakimiesliitto
      break
    case "Taloushallinto":
      query = allFeeds?.taloushallinto
      break
    default:
  }

  const links = query?.edges

  const linksFormatted = Array.isArray(links)
    ? links
        .map((item) => {
          const date = item?.node?.content
            ?.split("</p>")[0]
            ?.replace("<p>", "")
            ?.trim()
          return {
            url: item?.node?.link,
            title: `${date} ${item?.node?.title}`,
            target: "_blank",
            sortDate: dayjs(
              item?.node?.content?.split("-")[0],
              "D-M-YYYY"
            ).format(`YYYY-MM-DD`),
          }
        })
        .sort((a, b) => (a.sortDate > b.sortDate ? 1 : -1))
        .slice(0, limit)
    : []

  const archiveLink = link?.url ? [{ special: true, ...link }] : []

  return query ? (
    <LinkList heading={heading} list={linksFormatted.concat(archiveLink)} />
  ) : (
    ""
  )
}

export const query = graphql`
  fragment RSSFeed on WpBlockAcfRssFeed {
    __typename
    blockDataRSSFeed {
      heading
      selectedFeed
      limit
      link {
        url
        title
        target
      }
    }
  }
`

export default LinkListBlock
